export class Token {

  private $raw;
  private $timeout;
  private claims: any;

  constructor(token: string) {
    this.claims = this.parse(this.split(token)[1]);
    this.$raw = token;
    this.$timeout = this.claims.exp * 1000;
  }

  private split(jwt: string): string[] {
    return jwt.split('.');
  }

  private parse(base64: string): any {
    if (!base64) {
      return undefined;
    }

    return JSON.parse(this.b64DecodeUnicode(base64));
  }

  private b64DecodeUnicode(str) {
    return decodeURIComponent(Array.prototype.map.call(atob(str), (c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  claim(key: string): any {
    return this.claims[key];
  }

  get raw(): string {
    return this.$raw;
  }

  get timeout(): number {
    return this.$timeout;
  }

}
